<template>
    <div class="main-div">
        <v-header title="ESG示例介绍"></v-header>
        <div class="ESGExampleShow">
            <!-- 简介 -->
            <div class="introductory">
                <h2>什么是ESG？</h2>
                <p>ESG是Environmental（环境）、Social（社会）、和Governance（治理）的缩写，是一种关注企业环境、社会、公司治理绩效而非传统财务绩效的投资理念和企业评价标准。环境是指考虑企业对环境的影响，例如企业环保政策、员工环保意识、生产废弃物排放措施等；社会是指考虑企业对社会的影响，例如企业社区关系、员工健康、职场性别平等等；治理是指考虑企业的公司治理，例如内部权力争夺、管理层的有效监督、高管腐败等。投资者可以通过观测企业ESG评级来评估投资对象在绿色环保、履行社会责任等方面的贡献，对企业是否符合长期投资作出判断。</p>
                <p>目前国际上ESG理念及评体系主要包括三方面：各国际组织和交易所关于ESG披露和报告的规定、评级机构对企业ESG的评级、以及投资机构发布的ESG投资指引。在企业ESG评级体系中，不同的评级机构所关注的指标有所不同，部分常见ESG指标如下表所示。</p>
                <el-table :data="tableData" style="width: 45%;position: relative;top: 50%;left: 25%;">
                    <el-table-column
                        prop="environment"
                        label="环境"
                        width="160">
                    </el-table-column>
                    <el-table-column
                        prop="society"
                        label="社会"
                        width="160">
                    </el-table-column>
                    <el-table-column
                        prop="governance"
                        label="公司治理"
                        width="160">
                    </el-table-column>
                </el-table>
                <h2>ESG在国际和国内的发展</h2>
                <p>类似ESG的概念是上世纪诞生的伦理投资，当时投资者出于自身信仰或为社会创造积极价值所产生的投资理念。随着经济的高速增长对社会和环境造成越来越多负面影响，投资者的环保意识在环保运动的影响下逐渐增强，环境相关法律法规不断完善，责任投资和ESG理念进入专家、政府、机构和投资者的视线。目前国际组织、各国监管部门、投资机构发布的信息披露标准和评价标准已将ESG理念体系深化完善，ESG投资已成为国际市场主流策略之一，国际投资公司也在逐步推出ESG投资产品。根据UN-PRI（United Nations-supported Principles for Responsible Investment，联合国责任投资原则组织）2019年第三季度报告，全球已经超过2450家机构成为签署成员，成员拥有或管理的总资产规模超过82万亿美元，并且还在快速增长中。</p>
                <p>不同于国际上，国内ESG推广还处于初期阶段，目前中国已加入UN-PRI的机构共有30家，其中有25家是在2017年之后才加入的。但随着国家对绿色发展、绿色金融的大力推动以及2018年A股纳入MSCI指数后MSCI对A股公司ESG披露的要求，ESG相关制度规则也逐步出台，例如证监会修订后《上市公司治理准则》明确了ESG信息披露的基本框架；中基协发布《中国上市公司ESG评价体系研究报告》和《绿色投资指引（试行）》等。随着中国经济逐步转型，生态环保、绿色金融等理念将成为全社会的内在需求和普遍共识，ESG相关制度也将逐步完善，推动ESG理念在国内快速发展。</p>
            </div>
            <!-- 报告 -->
            <div class="report">
                <h2>规范透明高效的公司治理方能基业长青、行稳致远</h2>
                <p>联想一直是国内先进企业治理的先驱者之一。联想多年来开展严格的合规管理，并保持最高标准的商业道德，将诚信、反腐败、员工健康与福利、数据隐私安全等理念融入到公司企业文化、科技创新与业务发展之中。规范、透明且高效的公司治理结构正是联想多年来保持可持续增长的关键，也受到了认可。联想已经连续七年荣获香港会计师工会（HKICPA）颁发的最佳企业治理白金奖。</p>
                <p>联想还将自身ESG实践推广至一级供应商及产业链供应链上下游企业，促进企业降低运营对环境的影响，推广负责任材料采购，促进产品研发和生产质量，改善合作企业雇员的工作环境，保障员工合法权益。目前95%的供应商获得质量、环境及职业安全方面的多项国际认证。</p>
                <p>此外，联想还专注于全面创新，创造科技新体验。联想在全球拥有15个研发基地，每年研发投入达100亿人民币，带领1万名工程师勇攀技术高峰，累计获得超过2.9万项专利，其中包含逾1000项5G专利。今年联想陆续推出全球首款5GPC、首款可折叠笔记本电脑ThinkPadX1Fold，以及摩托罗拉刀锋5G折叠屏手机，引领折叠屏和5G技术实现全面商用。</p>
                <h2>十年减排92%，智能循环经济支持可持续发展</h2>
                <p>通过优化生产、运营、供应链和产品生命周期管理过程，联想超额完成了此前设定的可持续发展目标。于2009/10财年的数据相比，联想2019/20财年所有业务减少了92%的温室气体排放，超额完成了40%。联想还通过实施节能项目并使用可再生能源实现，扩大对于可持续发展运营的投入，联想目前于全球工厂安装的太阳能装置总容量达到16兆瓦。</p>
                <p>在此基础上，联想为2029/2030财年提出了新目标——到2030年，实现公司运营性直接及间接碳排放减少50%、部分价值链的碳排放强度降低25%、达成接近温室气体净零排放，为全球控温做出更大贡献。这一目标的设定符合全球科学碳目标倡议（SBTi）。</p>
                <p>以智能循环设计、智能循环使用和智能循环回收为三大重要抓手的循环经济则是联想环保承诺的另一重要体现。一直以来，联想专注于开发和设计优质环保型产品，在消费者使用环节推出相应服务模式和选项优化产品和资源的使用，并通过产品回收计划，最大程度减少供应链对新零件和材料的需求。在不懈的努力下，联想已扩大使用CL-PCR材料的产品范围，由2018/2019财年的21款产品增加至2019/2020财年的66款产品，214%的增幅彰显联想对支持循环经济的承诺。</p>
                <h2>积极承担社会责任，助力全球抗“疫”</h2>
                <p>在疫情期间，联想充分发挥智能技术领域的优势尽绵薄之力。当疫情暴发时，联想迅速启动紧急驰援武汉行动，捐赠火神山和雷神山医院所有IT设备。联想集团董事长兼CEO杨元庆通过“联想益学堂”公益项目，向湖北省包括孝感市大悟县在内的“三市四县”捐赠总价值1000万的平板电脑和网卡，保障缺少网络和终端的孩子们在疫情期间“停课不停学”。此外，联想与华大基因和英特尔通力合作，利用超算技术为基因测速提供高达40倍的加速，助力新冠病毒特性研究。</p>
                <p>此外，在日本，在美国、意大利、巴西，在全球各地，联想为医院、学校和低收入家庭捐赠电脑和平板，帮助实现医疗救助、远程教育。现在联想在全球的捐献金额已超过1，300万美元。</p>
                <h2>打造多元化包容组织，联想再次入选彭博性别平等指数</h2>
                <p>自成立以来，联想一直致力于打造多元化及平等的工作场所和生态系统，为每个人提供“没有天花板的舞台”。2019/20财年是公司第二年发布《多元化与包容性年度报告》，现在联想最高级管理层14名人员中包括三名女性，全球女性高管占比达18.5%，非高管女性员工占比36.2%，均呈上升趋势，员工敬业度得分超过90%。联想组织内多元化及包容性举措也获得了各方嘉许，2020年联想再次入选彭博性别平等指数，且两名副总裁名列福布斯中国《2019科技女性榜》。“ESG将成为中国实现经济高质量发展的重要抓手，对于我国诸多企业在“十四五”期间实现产业结构调整升级和产业链、供应链、创新链的健康发展具有重要意义，”联想集团董事长兼CEO杨元庆说。“联想将持续发挥自身作为ESG领导者和行业龙头企业的表率作用，帮助各界企业通过ESG实现和提高自身价值，为中国经济的高质量发展做出贡献。”</p>
            </div>
            <el-button size="medium" @click="goBack" style="position: relative;bottom: 10px;left: 50%;">返回</el-button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import vHeader from '@/layout/Header1.vue'
export default {
  components: {vHeader},
  data () {
    return {
        tableData: [
            {
                environment: '环境政策',
                society: '精准扶贫',
                governance: '股权结构'
            }, 
            {
                environment: '绿色技术',
                society: '产业扶贫',
                governance: '会计政策'
            },
            {
                environment: '环保投入',
                society: '乡村振兴',
                governance: '薪酬体系'
            },
            {
                environment: '温室气体排放',
                society: '社区沟通',
                governance: '风险管理'
            },
            {
                environment: '员工换包意识',
                society: '公益慈善',
                governance: '信息披露'
            },
            {
                environment: '节能减排措施',
                society: '隐私数据保护',
                governance: '道德行为准则'
            },
            {
                environment: '绿色采购政策',
                society: '员工福利与健康',
                governance: '反不公平竞争'
            },
            {
                environment: '废弃物污染及管理',
                society: '产品质量与安全',
                governance: '董事会独立性'
            },
            {
                environment: '政策',
                society: '供应链责任管理',
                governance: '董事会多样性'
            }
        ]
    }
  },
  watch: {},
  methods: {
      goBack () {
          this.$router.go(-2)
      }
  },
  mounted () {},
  activated () {}
}
</script>

<style scoped>
.ESGExampleShow {
    margin-top: 90px;
}
.introductory,.report {
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/performance/ESGExampleShow.vue